import { render, staticRenderFns } from "./CustomerCreate.vue?vue&type=template&id=7c7fd143&scoped=true&"
import script from "./CustomerCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerCreate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreate.vue?vue&type=style&index=0&id=7c7fd143&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7fd143",
  null
  
)

export default component.exports